export function getCurrentEmployeeName(): string {
  return (App.config.accountEmployeeName() || App.config.accountFullName() || '').trim();
}
